module.exports = "<div>\n  <cancel></cancel>\n</div>\n";